<template>
    <div class="toggle-button" :style="cssVars">
        {{ label }}
        <toggle-button
            v-model="checked"
            :value="value"
            @change="handleChange"
            :color="{checked: '#5271FF', unchecked: '#CCCCCC'}"
            :sync="true"
            :disabled="editable"
        >
        </toggle-button>
    </div>
</template>

<script>
    import { ToggleButton } from 'vue-js-toggle-button'

    export default {
        name: 'totem-toggle-button',
        components: {
            ToggleButton
        },
        props: {
            value: Boolean,
            label: String,
            editable: {
                type: Boolean,
                default: false
            },
            width: {
                type: [Number, String],
                default: 285
            }
        },
        data () {
            return {
                checkedProxy: false
            }
        },
        computed: {
            checked: {
                get () {
                    return this.value
                },
                set (val) {
                    this.checkedProxy = val
                }
            },
            cssVars () {
                return {
                    '--width': `${this.width}px`
                }
            }
        },
        methods: {
            handleChange (e) {
                this.$emit('input', this.checkedProxy)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .toggle-button {
        font-family: PlusJakartaSans-Regular, sans-serif;
        min-width: var(--width);
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 48px;
        border: 1px solid $lavender;
        background-color: $white;
        padding: 0 15px;
        border-radius: 10px;
        font-size: 1.6rem;
        line-height: 1;

        [class*="mobile"] & {
            width: 100%;
        }

        > label {
            margin-left: 10px;
        }
    }
</style>
